import React, { useEffect, useState } from "react";

const CuSwitcher = ({ toggle, setToggle }) => {
  const [isChecked, setIsChecked] = useState(false);

  // useEffect(() => {
  //   //(toggle, 'dshakjs1')
  //   setIsChecked(toggle);
  // }, [toggle]);

  const handleToggleChange = (e) => {
    //(e.target.checked, 'dshakjs')
    setToggle(e.target.checked);
    // setIsChecked(e.target.checked);
    // setToggle((prevState) => ({
    //   ...prevState,
    //   toggle: e.target.checked,
    // }));
  };

  return (
    <div className="flex items-center">
      {<span className="mr-2 text-sm">All Clinics</span>}
      <label className="relative cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={toggle}
          onChange={handleToggleChange}
        />
        <div
          className={`w-11 h-6 flex items-center bg-gray-300 rounded-full peer ${
            toggle ? "peer-checked:after:translate-x-full" : ""
          } after:absolute after:left-[2px] peer-checked:after:border-white after:bg-white after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#C7EAC9]`}
        ></div>
      </label>
    </div>
  );
};

export default CuSwitcher;
